import { useInfiniteQuery } from "@tanstack/react-query";
import { queryRoots, api, offsetPaging, PAGE_SIZE } from "@/shared/api";

export const searchKeys = {
  all: queryRoots.search,
  results: (q: string, bucket: string | undefined, sort: string, order: string) =>
    [...searchKeys.all, q, bucket ?? "all", sort, order] as const,
};

export function useSearch(params: {
  q: string;
  bucket?: string;
  sort: "name" | "date" | "size";
  order: "asc" | "desc";
}) {
  return useInfiniteQuery({
    queryKey: searchKeys.results(params.q, params.bucket, params.sort, params.order),
    enabled: params.q.length >= 1,
    queryFn: async ({ pageParam, signal }) => {
      const { data } = await api.GET("/search", {
        params: {
          query: {
            q: params.q,
            bucket: params.bucket,
            sort: params.sort,
            order: params.order,
            limit: PAGE_SIZE,
            offset: pageParam,
          },
        },
        signal,
      });
      if (!data) throw new Error("Empty search response");
      return data;
    },
    ...offsetPaging,
  });
}
